export default __webpack_public_path__ + "static/media/ici.8b7ba4f9.svg";